import React from 'react';
import { InstagramIcon, MapPinIcon } from 'lucide-react';
import { Logo } from './Logo';
import { bookingUrl, contact, navLinks } from '../data/site';
export function Footer() {
  return <footer id="contact" className="bg-ink pb-24 pt-16 text-white/75 sm:pb-12" data-id="element-1" data-mp="32o4c8dvrme84">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8" data-id="element-2" data-mp="32m1ef7odfgsu">
        <div className="lg:col-span-5" data-id="element-3" data-mp="36nd6djupwe47">
          <Logo inverted data-id="element-4" data-mp="3ueim7z0nr6ei" />
          <h2 className="mt-8 font-serif text-3xl font-medium text-white" data-id="element-5" data-mp="3ugbqx8rpngjv">Venir à l’institut</h2>
          <address className="mt-4 not-italic leading-relaxed" data-id="element-6" data-mp="37fth3568s26">
            {contact.address}
            <br data-id="element-7" data-mp="3ldap3k9vobm0" />
            {contact.city}
          </address>
          <div className="mt-6 flex flex-wrap gap-3" data-id="element-8" data-mp="3qd6qdbr6xoxv">
            <a href={bookingUrl} className="whitespace-nowrap rounded-full bg-white px-6 py-3 text-sm font-bold text-ink transition-colors duration-150 hover:bg-cream" data-id="element-9" data-mp="3qbvq3lwyezbi">
              Réserver un soin
            </a>
            <a href={contact.mapsUrl} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/30 px-6 py-3 text-sm font-bold text-white transition-colors duration-150 hover:border-white" data-id="element-10" data-mp="3l90mnssh4sxo">
              <MapPinIcon className="h-4 w-4" aria-hidden data-id="element-11" data-mp="3v5dgcqo0r6sf" />
              Itinéraire
            </a>
          </div>
        </div>

        <nav aria-label="Pied de page" className="lg:col-span-4" data-id="element-12" data-mp="82icpt2wkaeu">
          <ul className="grid grid-cols-2 gap-3" data-id="element-13" data-mp="80nrsermsiar">
            {navLinks.map(l => <li key={l.label} data-id="element-14" data-mp="31uqdkpmchqy">
                <a href={l.href} className="transition-colors duration-150 hover:text-white" data-id="element-15" data-mp="hsk34riqa4wx">
                  {l.label}
                </a>
              </li>)}
            <li data-id="element-16" data-mp="cw34h3dwk85l">
              <a href="https://commeuncharme.fr/blog" className="transition-colors duration-150 hover:text-white" data-id="element-17" data-mp="qt8ipqnrsdbx">
                Blog
              </a>
            </li>
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-18" data-mp="tvczjrxji5f5">
          <a href={contact.instagram} className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-19" data-mp="twfohubaxxsf">
            <InstagramIcon className="h-5 w-5" aria-hidden data-id="element-20" data-mp="13tkanu55dt98" />
            @institutcommeuncharme
          </a>
        </div>
      </div>
      <p className="mx-auto mt-14 max-w-7xl border-t border-white/10 px-5 pt-6 text-sm text-white/55 lg:px-8" data-id="element-21" data-mp="18ksp54lc44t9">
        © {new Date().getFullYear()} Comme un Charme · Spa & institut de beauté, Paris 16e
      </p>
    </footer>;
}